function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from "react";
import merge from "lodash/merge";
import { LapelError } from "../../logger";
var ChildPropMerger = function(param) {
    var children = param.children, overrideProps = param.overrideProps, _param_mergeChildProps = param.mergeChildProps, mergeChildProps = _param_mergeChildProps === void 0 ? true : _param_mergeChildProps;
    if (!children) {
        return null;
    }
    if (mergeChildProps && (!overrideProps || Object.keys(overrideProps).length === 0)) {
        return children;
    }
    // PropMerging only works with a single child.
    if (children.length > 1) {
        throw new LapelError("Prop merging is not supported with more than one child.");
    }
    if (mergeChildProps) {
        var _children;
        var mergedProps = merge({}, ((_children = children) == null ? void 0 : _children.props) || {}, overrideProps);
        return /*#__PURE__*/ React.cloneElement(React.Children.only(children), mergedProps);
    }
    // Creates the inverse JS object to set all children props to undefined
    var invertedProps = Object.keys(children.props).reduce(function(prev, curr) {
        Object.assign(prev, _define_property({}, curr, undefined));
        return prev;
    }, {});
    var unmergedProps = merge({}, invertedProps, overrideProps);
    // Children props are immutable and copied when cloning an element by default
    // There is no way to remove props, but the shallow merge function that accepts updated props
    // Allows undefined's to set the value to undefined.
    // Here we set all prop keys to undefined, then merge back in the overridden values
    return /*#__PURE__*/ React.cloneElement(React.Children.only(children), unmergedProps);
};
export { ChildPropMerger };

//# sourceMappingURL=ChildPropMerger.js.map